/* ==========================================================================
   karriere.js
   Zwei kleine Aufgaben auf /pages/jobs:
   1. Klick auf „Auf X bewerben" waehlt die Stelle im Formular vor.
   2. Fortschrittliche Verbesserung des Bewerbungsformulars: Dateien vorab
      pruefen, per fetch abschicken, Status am Formular anzeigen.

   Ohne dieses Skript funktioniert alles trotzdem. Das Formular postet dann
   klassisch an den Worker, und der liefert selbst eine Bestaetigungsseite aus.
   Genau deshalb wird hier nichts erzwungen, was der Server nicht auch koennte.
   ========================================================================== */
(function () {
  'use strict';

  /* ---------------------------------------------- Kundentexte

     Diese Datei kann kein Liquid — ein `| t` hier waere woertlich in der
     ausgelieferten Datei zu lesen. Die Texte kommen deshalb wie bei theme.js
     und custom.js aus `window.languages`; gesetzt wird das inline in
     sections/karriere.liquid aus locales/*.json.

     Der zweite Parameter ist der deutsche Rueckfall: Faellt das inline-Skript
     aus oder fehlt ein Schluessel, steht trotzdem ein Satz da statt nichts.
     Platzhalter haben die Form `{{ name }}` — genau so, wie sie in den
     Sprachdateien stehen; `| t` ohne Argument laesst sie woertlich stehen. */
  function txt(schluessel, rueckfall) {
    var wert = window.languages && window.languages[schluessel];
    return wert ? wert : rueckfall;
  }

  /* ---------------------------------------------- Stelle vorwaehlen */
  var wahl = document.getElementById('bw-stelle');
  if (wahl) {
    document.querySelectorAll('[data-karriere-waehlen]').forEach(function (a) {
      a.addEventListener('click', function () {
        var t = a.getAttribute('data-karriere-waehlen');
        for (var i = 0; i < wahl.options.length; i++) {
          if (wahl.options[i].value === t) {
            wahl.selectedIndex = i;
            break;
          }
        }
      });
    });
  }

  /* ---------------------------------------------- Karte auf Klick laden

     Zwei-Klick-Loesung. Die iframe-URL steht in data-karte-src und wird erst
     hier eingehaengt. Vorher geht kein Request an Google, also auch keine IP
     und kein Cookie vor der Einwilligung. Begruendung steht im Markup von
     sections/karriere.liquid.

     Dieser Block steht bewusst VOR dem return unten: ohne Worker-URL rendert
     die Seite Shopifys Kontaktformular, dann gibt es kein [data-karriere-form]
     und der Rest der Datei bricht ab. Die Karte muss trotzdem funktionieren. */
  var karte = document.querySelector('[data-karriere-karte]');
  var karteKnopf = karte && karte.querySelector('[data-karriere-karte-laden]');
  if (karte && karteKnopf) {
    karteKnopf.addEventListener('click', function () {
      var quelle = karte.getAttribute('data-karte-src');
      if (!quelle) return;
      var rahmen = document.createElement('iframe');
      rahmen.src = quelle;
      rahmen.title = karte.getAttribute('data-karte-titel') || txt('karriereKarte', 'Karte');
      rahmen.className = 'karriere-standort__iframe';
      rahmen.setAttribute('loading', 'lazy');
      rahmen.setAttribute('referrerpolicy', 'no-referrer-when-downgrade');
      rahmen.setAttribute('allowfullscreen', '');
      karte.innerHTML = '';
      karte.appendChild(rahmen);
      karte.className += ' karriere-standort__karte--geladen';
    });
  }

  /* ---------------------------------------------- Formular an den Worker */
  var form = document.querySelector('[data-karriere-form]');
  if (!form || typeof FormData === 'undefined' || !window.fetch) return;

  var status = form.querySelector('[data-karriere-status]');
  var knopf = form.querySelector('[data-karriere-senden]');
  var datei = form.querySelector('#bw-datei');
  var liste = form.querySelector('[data-karriere-dateiliste]');

  var maxAnzahl = parseInt(form.dataset.maxDateien, 10) || 3;
  var maxProDatei = (parseInt(form.dataset.maxProDatei, 10) || 8) * 1024 * 1024;
  var maxGesamt = (parseInt(form.dataset.maxGesamt, 10) || 15) * 1024 * 1024;

  function zeige(art, text) {
    if (!status) return;
    status.hidden = false;
    status.className = 'karriere-form__status karriere-form__status--' + art;
    status.textContent = text;
    if (art === 'fehler') status.setAttribute('role', 'alert');
    else status.setAttribute('role', 'status');
  }

  function verstecke() {
    if (status) status.hidden = true;
  }

  function kb(n) {
    return n < 1024 * 1024
      ? Math.round(n / 1024) + ' KB'
      : (n / 1024 / 1024).toFixed(1).replace('.', ',') + ' MB';
  }

  /** Prueft die Auswahl im Browser. Der Worker prueft dieselben Regeln noch
      einmal; das hier erspart dem Bewerber nur den vergeblichen Upload. */
  function dateienPruefen() {
    if (!datei || !datei.files || !datei.files.length) {
      if (liste) liste.hidden = true;
      return null;
    }
    var f = datei.files;
    if (f.length > maxAnzahl) {
      return txt('karriereMaxDateien', 'Bitte höchstens {{ anzahl }} Dateien.').replace(
        '{{ anzahl }}',
        maxAnzahl
      );
    }
    var gesamt = 0;
    var namen = [];
    for (var i = 0; i < f.length; i++) {
      if (f[i].size > maxProDatei) {
        /* Groesse VOR dem Namen ersetzen: ein Dateiname, der zufaellig
           „{{ groesse }}" enthaelt, wuerde sonst mitersetzt. */
        return txt('karriereDateiZuGross', '„{{ name }}" ist größer als {{ groesse }}.')
          .replace('{{ groesse }}', kb(maxProDatei))
          .replace('{{ name }}', f[i].name);
      }
      gesamt += f[i].size;
      namen.push(f[i].name + ' (' + kb(f[i].size) + ')');
    }
    if (gesamt > maxGesamt) {
      return txt('karriereGesamtZuGross', 'Zusammen {{ gesamt }}. Erlaubt sind höchstens {{ grenze }}.')
        .replace('{{ gesamt }}', kb(gesamt))
        .replace('{{ grenze }}', kb(maxGesamt));
    }
    if (liste) {
      liste.hidden = false;
      liste.textContent = namen.join(' · ');
    }
    return null;
  }

  if (datei) {
    datei.addEventListener('change', function () {
      var fehler = dateienPruefen();
      if (fehler) zeige('fehler', fehler);
      else verstecke();
    });
  }

  form.addEventListener('submit', function (e) {
    var fehler = dateienPruefen();
    if (fehler) {
      e.preventDefault();
      zeige('fehler', fehler);
      return;
    }

    e.preventDefault();
    var daten = new FormData(form);

    knopf.disabled = true;
    var alteBeschriftung = knopf.textContent;
    knopf.textContent = txt('karriereSendet', 'Wird gesendet…');
    zeige(
      'laeuft',
      txt(
        'karriereLaeuft',
        'Deine Bewerbung geht raus. Das kann bei großen Anhängen einen Moment dauern.'
      )
    );

    fetch(form.action, {
      method: 'POST',
      body: daten,
      headers: { Accept: 'application/json' },
    })
      .then(function (r) {
        return r.json().then(function (j) {
          return { ok: r.ok, body: j };
        });
      })
      .then(function (res) {
        if (res.ok && res.body && res.body.ok) {
          form.innerHTML =
            '<p class="karriere-form__ok" role="status">' +
            txt(
              'karriereDanke',
              'Danke, deine Bewerbung ist bei uns. Wir lesen sie selbst und melden uns innerhalb einer Woche.'
            ) +
            '</p>';
          form.scrollIntoView({ block: 'center', behavior: 'smooth' });
          return;
        }
        throw new Error(
          (res.body && res.body.fehler) || txt('karriereUnbekannt', 'Unbekannter Fehler.')
        );
      })
      .catch(function (err) {
        knopf.disabled = false;
        knopf.textContent = alteBeschriftung;
        zeige(
          'fehler',
          (err && err.message
            ? err.message
            : txt('karriereFehlgeschlagen', 'Das hat nicht geklappt.')) +
            ' ' +
            txt(
              'karriereFehlerZusatz',
              'Wenn es weiter hakt, schick deine Bewerbung bitte per Mail.'
            )
        );
      });
  });
})();
